import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { AuthorizationService } from '../services/authorization/authorization.service';
import { WorkOrdersService } from '../services/workorders/work-orders.service';
import * as moment from 'moment';

@Injectable()
export class OngoingOrderGuard implements CanActivate {
  today = moment().toDate();

  constructor(private authorizationService: AuthorizationService,
              private workOrderService: WorkOrdersService,
              private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> {


    // check for User

    return this.workOrderService.getOrders(this.today)
      .pipe(
        take(1),
        map(orders => {
            console.log(orders);
            const filteredOrders = orders.filter(order => {
              if (order.status === 'inProgress') {
                return order;
              }
              if (order.status === 'paused') {
                return order;
              }
            });
            if (filteredOrders.length) {
              if (filteredOrders.length > 1) {
                filteredOrders.sort((a, b) => {
                  return a.orderDate.toMillis() - b.orderDate.toMillis();
                });
              }
              const order = filteredOrders[0];
              if (this.router.url.includes('auth/orders/')) {
                return true;
              }
              this.router.navigateByUrl('auth/orders/' + order.id);
              return false;
            }
            return true;
          },
        )
      );
  }
}


